import { createSlice, Dispatch, PayloadAction } from '@reduxjs/toolkit';
import { MenuSummary } from '@pepperhq/menu-sdk';
import { menusApi } from 'components/menu-manager/MenusApi';
import logger from 'lib/logger';

export interface MenuManagerState {
    menuSummaryList: MenuSummary[];
    hasLoaded: boolean;
    isLoading: boolean;
}

export const initialState: MenuManagerState = {
    menuSummaryList: [],
    hasLoaded: false,
    isLoading: false
};

const menuManagerSlice = createSlice({
    name: 'menuManager',
    initialState,
    reducers: {
        startRequest: state => {
            state.isLoading = true;
        },
        endRequest: state => {
            state.isLoading = false;
            state.hasLoaded = true;
        },
        getMenuSummaryListSuccess: (state, action: PayloadAction<MenuSummary[]>) => {
            state.menuSummaryList = action.payload;
        }
    }
});

export const { startRequest, endRequest, getMenuSummaryListSuccess } = menuManagerSlice.actions;

export const getMenuSummaryList = async (dispatch: Dispatch) => {
    try {
        dispatch(startRequest());
        const menuSummaryList = await menusApi.getMenus();

        if (menuSummaryList.ok) {
            dispatch(getMenuSummaryListSuccess(menuSummaryList.body));
        }

        return menuSummaryList;
    } catch (error) {
        logger.error('Failed to load a menu summary.', error.message);
    } finally {
        dispatch(endRequest());
    }
};

export default menuManagerSlice.reducer;
